import { useEffect } from "react";
import { useDebounce, useMerchantApiMutation } from "../../hooks";
import {
  IResolveGatewayMerchantRequest,
  IResolveGatewayMerchantResponse,
} from "../../interfaces-and-types";
import { View } from "./View";

export interface IGatewayMerchantResolverProps {
  country: string;
  currency: string;
  merchantIdOrCode: string;
  recipientGatewayCode: string;

  isGatewayMerchantResolved: boolean;
  setGatewayMerchantResolved: (isResolved: boolean) => void;
  setResolvedGatewayMerchantDetails?: (
    resolvedDetails: IResolveGatewayMerchantResponse
  ) => void;
}

export interface IGatewayMerchantResolverViewProps {
  isLoading: boolean;
  isError: boolean;
  isGatewayMerchantResolved: boolean;
  merchantName: string | null;
  errorMessage: string | null;
}

export const GatewayMerchantResolver = (
  props: IGatewayMerchantResolverProps
) => {
  const {
    merchantIdOrCode: merchant_id_or_code,
    recipientGatewayCode: recipient_gateway_code,
    country,
    currency,
    isGatewayMerchantResolved,
    setGatewayMerchantResolved,
    setResolvedGatewayMerchantDetails,
  } = props;

  const {
    isLoading,
    isSuccess,
    isError,
    data: gatewayMerchantDetailsApiResponse,
    mutate: resolveGatewayMerchant,
  } = useMerchantApiMutation<
    IResolveGatewayMerchantRequest,
    IResolveGatewayMerchantResponse
  >("resolveGatewayMerchant", null, {
    ignoreActivityBlocker: true,
  }).usePostMutation;

  useEffect(() => {
    // if (isGatewayMerchantResolved) {
    setGatewayMerchantResolved(false);
    // }
  }, [merchant_id_or_code, recipient_gateway_code, country, currency]);

  useEffect(() => {
    if (isSuccess) {
      setGatewayMerchantResolved(true);
      setResolvedGatewayMerchantDetails &&
        setResolvedGatewayMerchantDetails(
          gatewayMerchantDetailsApiResponse.data
        );
    }
  }, [isSuccess]);

  const debouncePeriodElapsed = useDebounce(
    1500,
    `${merchant_id_or_code}${recipient_gateway_code}${country}${currency}`
  );

  const accountInfoSupplied =
    !!merchant_id_or_code &&
    !!recipient_gateway_code &&
    !!country &&
    !!currency &&
    merchant_id_or_code.length >= 3 &&
    debouncePeriodElapsed; // TODO: use country codes to determine length of acc number

  useEffect(() => {
    if (accountInfoSupplied && !isGatewayMerchantResolved)
      resolveGatewayMerchant({
        merchant_id_or_code,
        recipient_gateway_code,
        country,
        currency,
      });
  }, [
    isGatewayMerchantResolved,
    accountInfoSupplied,
    merchant_id_or_code,
    recipient_gateway_code,
    country,
    currency,
  ]);

  // const { message: errorMessage = "Account number could not be verified..." } =
  //   (error as any)?.data;

  return (
    <View
      isLoading={isLoading}
      isError={isError}
      isGatewayMerchantResolved={isGatewayMerchantResolved}
      merchantName={
        gatewayMerchantDetailsApiResponse?.data?.merchant_name ?? null
      }
      errorMessage={"Merchant could not be verified..."}
    />
  );
};
